module.exports = __webpack_public_path__ + "static/media/mapbox.da799b22.png";